import api from ".";

const path = "/question";

const getBySection = id => api.get(`${path}/bySectionId/${id}`);

export default {
  getBySection,
};
